module.exports = __webpack_public_path__ + "media/newstyle/images/bookmark_heart-2e275b07f25ca613ceec5c3d57efbce4.svg";